import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import momentActions from "app/utils/momentActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

import TextInput from "app/components/TextInput";
import DatePicker from "app/components/DatePicker";

export default class MomentForm extends React.Component {
  static propTypes = {
    moment: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isDirty: false,
      moment: props.moment,
    };
  }

  render() {
    let { isDirty, loading, moment } = this.state;

    let value = moment.value;
    let note = moment.note;

    return (
      <View
        style={{
          flexDirection: "row",
          padding: sizes.base,
          backgroundColor: colors.fill,
        }}
      >
        <View style={{ width: 150 }}>
          <Text bold>MOMENT</Text>
          <Text bold>ID</Text>
          <Text bold>Chapter ID</Text>
          <Text bold>Value ID</Text>
          <Text bold>Created At</Text>
          <Text bold>Updated At</Text>
          <Text bold>Index</Text>
          <Text bold>Text</Text>
          <Text bold>Completed At</Text>
          <TouchableOpacity onPress={this.props.onClose}>
            <Text button center>
              Cancel
            </Text>
          </TouchableOpacity>
        </View>
        <View style={{}}>
          <Text> </Text>
          <Text>{moment.id}</Text>
          <Text>{moment.chapter_id}</Text>
          <Text>{moment.value_id}</Text>
          <Text>{moment.created_at}</Text>
          <Text>{moment.updated_at}</Text>
          <Text>{moment.index}</Text>
          <Text>{moment.tex || "–"}</Text>
          <View style={{ flexDirection: "row" }}>
            <DatePicker
              selected={
                !!moment.completed_at ? new Date(moment.completed_at) : null
              }
              value={
                !!moment.completed_at ? new Date(moment.completed_at) : null
              }
              onChange={(timestamp) =>
                this.updateValue(
                  "completed_at",
                  timeHelpers.dateTimeToDate(timestamp)
                )
              }
              inputStyle={{ flex: 1 }}
              style={{ flex: 1 }}
            />
            {!!moment.completed_at && (
              <Text onPress={() => this.updateValue("completed_at", null)}>
                {" "}
                remove
              </Text>
            )}
          </View>
          <TouchableOpacity
            onPress={this.handleSubmit}
            disabled={!isDirty || loading}
          >
            <Text selectedButton center disabled={!isDirty || loading}>
              Save
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  updateValue = (key, val) => {
    let { moment } = this.state;
    moment[key] = val;
    this.setState({ moment, isDirty: true });
  };

  handleSubmit = async () => {
    let { moment } = this.state;
    this.setState({ loading: true });
    let res = await momentActions.update(moment.id, moment);
    this.setState({ loading: false });
    this.props.onClose();
  };
}

const styles = StyleSheet.create({
  style: {},
});
